<template>
  <div class="image-container">
    <img
      src="@/assets\images\busImage\arrow_left.png"
      :style="{ transform: `scale(${scale}) rotate(${rotation}deg)` }"
      @mousewheel="onWheel"
      @mousedown="onMouseDown"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
    />
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      imageSrc: '',
      scale: 1,
      rotation: 0,
      startX: 0,
      startY: 0,
      startRotation: 0
    };
  },
  methods: {
    onWheel(event) {
      event.preventDefault();
      const delta = event.wheelDelta ? event.wheelDelta : -event.deltaY;
      const scaleFactor = delta > 0 ? 1.1 : 1 / 1.1;
      this.scale *= scaleFactor;
    },
    onMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startRotation = this.rotation;
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    },
    onMouseMove(event) {
      this.rotation = this.calcRotation(event.clientX, event.clientY);
    },
    onMouseUp() {
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    },
    onTouchStart(event) {
      if (event.touches.length === 1) {
        event.preventDefault();
        this.startX = event.touches[0].pageX;
        this.startY = event.touches[0].pageY;
        this.startRotation = this.rotation;
      }
    },
    onTouchMove(event) {
      if (event.touches.length === 1) {
        event.preventDefault();
        this.rotation = this.calcRotation(event.touches[0].pageX, event.touches[0].pageY);
      }
    },
    calcRotation(x, y) {
      const dx = x - this.startX;
      const dy = y - this.startY;
      const degree = Math.atan2(dy, dx) * 180 / Math.PI;
      return this.startRotation + degree - this.rotation;
    }
  }
};
</script>
 
<style>
.image-container {
  width: 600px;
  height: 400px;
  overflow: scroll;
  position: relative;
}
 
.image-container img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center;
}
</style>